import script from "./AdministratorProjectAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectAgreement.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectAgreement.vue?vue&type=style&index=0&id=d944809c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d944809c"]])

export default __exports__